<template>
  <div>
    <el-dialog
      top="50px"
      width="1024px"
      :title="`Chọn ${selectedFileType.label} từ kho lưu trữ`"
      :visible="visible"
      append-to-body
      :show-close="!callingAPI"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="$emit('close')"
    >
      <div>
        <el-row
          type="flex"
          justify="space-between"
        >
          <el-input
            v-model="searchText"
            suffix-icon="el-icon-search"
            class="w-50"
            placeholder="Nhập tên để tìm kiếm"
            @input="listData"
          />
          <el-button
            v-if="permission.CREATE"
            type="primary"
            size="medium"
            icon="el-icon-upload"
            :plain="true"
            @click="() => (uploadVisible = true)"
            >Upload</el-button
          >
        </el-row>
        <div class="select-files">
          <p v-if="!files.length">Không có dữ liệu</p>
          <el-row
v-else
:gutter="12">
            <el-col
v-for="file in files"
:key="file.uid"
:lg="4">
              <div
                class="file-card"
                :class="
                  selectedFileIds.includes(file.id) ? `file-card__checked` : ''
                "
              >
                <FileCard
                  :file="file"
                  :type="selectedFileType.key"
                  :show-name="true"
                />
                <div class="file-card__check">
                  <el-button
                    circle
                    size="mini"
                    :type="
                      selectedFileIds.includes(file.id) ? 'primary' : 'info'
                    "
                    @click="handleCheck(file)"
                  >
                    <i class="el-icon-check" />
                  </el-button>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <span
slot="footer"
class="dialog-footer">
        <el-button
:disabled="callingAPI"
@click="$emit('close')"
          >Đóng</el-button
        >
        <el-button
          type="primary"
          :loading="callingAPI"
          :disabled="selectedFiles.length === 0"
          @click="handleConfirm"
          >Xác nhận</el-button
        >
      </span>
    </el-dialog>
    <UploadFilesPopup
      v-if="uploadVisible"
      :visible="uploadVisible"
      :selected-file-type="selectedFileType"
      @close="() => (uploadVisible = false)"
      @reload="listData"
    />
  </div>
</template>

<script>
import FileCard from "../items/FileCard.vue";
import UploadFilesPopup from "./UploadFiles.vue";
import constants from "@/config/constants";
import fileServices from "@/services/file";
import organizationServices from "@/services/organization"
import { filePer } from "@/utils/permission";

export default {
  name: "SelectFilesPopup",
  components: {
    FileCard,
    UploadFilesPopup,
  },
  props: {
    visible: Boolean,
    type: String,
    currentFiles: Array,
  },
  data() {
    return {
      loading: false,
      fileList: [],
      callingAPI: false,
      searchText: "",
      selectedFiles: [],
      uploadVisible: false,
      permission: filePer(),
      organizationId: organizationServices.getCurrentOrg()?.id
    };
  },
  computed: {
    selectedFileType() {
      return constants.FILE_TYPES.find((t) => t.key === this.type);
    },
    params() {
      const _params = {
        offset: 0,
        limit: 999,
        locale: "vi",
        sort: "-created"
      };
      _params.filters = {
        file_type: this.type,
        organization_id: this.organizationId,
      };
      if (this.searchText?.trim()) {
        _params.filters["extra.name"] = { $regex: this.searchText?.trim() };
      }
      return _params;
    },
    files() {
      const currentFileIds = this.currentFiles.map((f) => f.id);
      return this.fileList
        .filter((f) => !currentFileIds.includes(f.id))
        .slice(0, 12);
    },
    selectedFileIds() {
      return this.selectedFiles.map((f) => f.id);
    },
  },
  beforeMount() {
    this.listData();
  },
  methods: {
    listData() {
      this.loading = true;
      this.selectedFiles = [];
      fileServices
        .list(this.params)
        .then((response) => {
          this.fileList = response.items.map((item) => ({
            id: item.id,
            name: item.extra.name,
            url: item.url,
            extra: item.extra,
          }));
          this.loading = false;
        })
        .catch(() => {
          this.data = [];
          this.loading = false;
        });
    },
    handleCheck(file) {
      if (!this.selectedFileIds.includes(file.id)) {
        this.selectedFiles.push(file);
      } else {
        this.selectedFiles = this.selectedFiles.filter((f) => f.id !== file.id);
      }
    },
    handleConfirm() {
      this.$emit("selected", this.selectedFiles);
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss">
.select-files {
  margin-top: 24px;
  .file-card {
    border: 2px solid #f1f1f1;
    padding: 4px;
    border-radius: 12px;
    position: relative;
    margin-bottom: 16px;
    &__checked {
      border-color: #409eff;
    }
    .file-image,
    .file-other {
      width: 100%;
      border-radius: 12px;
      cursor: pointer;
    }
    .file-video {
      width: 100%;
      height: 100px;
      border-radius: 12px;
      cursor: pointer;
    }
    .file-audio {
      width: 100% !important;
    }
    &__check {
      position: absolute;
      top: 0;
      right: 4px;
    }
  }
}
</style>
